import Vue from "vue";
import * as rt from "../../../routes/routes";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router";

export const actions = {
  newDriver({ commit }) {
    let driverDetail = {
      drivers_name: $(".drivers_name").val(),
      id_passport_no: $(".id_passport_no").val(),
      phone_number_ke: $(".phone_number_ke").val(),
      phone_number_su: $(".phone_number_su").val()
    };
    $(".creatingDriver").hide(), $(".creatingDriverLoader").show();
    baseurl.post(rt.newDriver, driverDetail).then(res => {
      $(".creatingDriver").show(), $(".creatingDriverLoader").hide();

      if (res.data.code === 200) {
        $(".form-control").val("");
        window.$("#new-driver").modal("hide");
        commit("STORE_DRIVERS", res.data.drivers);
        suc.driversCreateSuccess();
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.DriversExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingDrivers();
      } else if (res.data.code === 405) {
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        window.$("#new-driver").modal("hide");
        ses.sessionComplete();
      }
    });
  },

  loadDrivers({ commit }) {
    baseurl.get(rt.loadDrivers).then(res => {
      $(".driversLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_DRIVERS", res.data.drivers);
      } else if (res.data.code === 404) {
        ers.errorLoadingDrivers();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        commit("STORE_DRIVERS", []);
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  viewDriver({ commit }, driverId) {
    commit("STORE_DRIVER_UPDATE", driverId);
    window.$("#update-driver").modal("show");
  },

  driverUpdate({ commit }) {
    let driverDetail = {
      id: $(".id").val(),
      drivers_name: $(".Udrivers_name").val(),
      id_passport_no: $(".Uid_passport_no").val(),
      phone_number_ke: $(".Uphone_number_ke").val(),
      phone_number_su: $(".Uphone_number_su").val()
    };
    $(".updatingDriver").hide(), $(".updatingDriverLoader").show();
    baseurl.post(rt.updateDriver, driverDetail).then(res => {
      $(".updatingDriver").show(), $(".updatingDriverLoader").hide();

      if (res.data.code === 200) {
        window.$("#update-driver").modal("hide");
        suc.driversUpdateSuccess();
        setTimeout(() => {
          commit("STORE_DRIVERS", res.data.drivers);
        }, 1000);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorUpdatingDrivers();
      } else if (res.data.code === 405) {
        window.$("#update-driver").modal("hide");
        ers.noPermissionToUpdate();
      } else if (res.data.code === 506) {
        window.$("#update-driver").modal("hide");
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/drivers/actions.js